// 分期付款
<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">分期付款</div>
      <div class="table">
        <div class="table-title">
          <div class="text">
            分期标的名称：
            <span>{{info.name}}</span>
          </div>
          <div class="text">
            分期金额（元）：
            <span>{{info.stageAmount}}</span>
          </div>
          <div class="text">
            分期期数：
            <span>{{info.stageNum}}</span>
          </div>
          <div class="text">
            首期金额（元）：
            <span>{{info.firstAmount}}</span>
          </div>
        </div>
        <el-table class="financial-services-table" :data="tableData" v-loading="loading" :header-cell-style="{
            textAlign: 'center',
            background: '#FAFAFA',
            color: '#3F434B',
          }" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="stageNum" label="期数"/>
          <el-table-column prop="amount" label="本期分期金额（元）"/>
          <el-table-column prop="lateAmount" label="滞纳金（元）"/>
          <el-table-column prop="duesAmount" label="本期应付金额（元）"/>
          <el-table-column prop="latestDate" width="150px" label="最晚付款时间"/>
          <el-table-column prop="actualDate" width="150px" label="实际付款时间">
              <template slot-scope="scope">
                  {{scope.row.actualDate?scope.row.actualDate:'--'}}
              </template>
          </el-table-column>
          <el-table-column label="付款情况">
            <template slot-scope="scope">
                <span v-if="scope.row.status == 1 || scope.row.status == 2">{{scope.row.status == 1?'已支付':'待确认'}}</span>
                <span class="blueC" v-else @click="payStage(scope.row)">{{scope.row.status == 3?'重新支付':'去支付'}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <faceQrcode v-if="qrShow" ref="qr" @notify="notify"></faceQrcode>
      <el-dialog title="分期支付" v-loading.fullscreen.lock="diaLoading" :visible.sync="show" :close-on-click-modal="false" width="60%">
        <div class="transfer_wrap">
          <div class="h_bg p50" style="margin-top: -20px">
            <h3>分期信息</h3>
          </div>
          <div class="p50" style="margin-bottom: 30px">
            <div class="mb10">
              <span class="wid">分期金额（元）</span>
              <span>{{ info.stageAmount }}</span>
            </div>
            <div class="mb10">
              <span class="wid">分期期数</span>
              <span>{{ info.stageNum }}</span>
            </div>
            <div class="mb10">
              <span class="wid">剩余每期金额（元）</span>
              <span>{{ info.laterAmount }}</span>
            </div>
            <div class="mb10">
              <span class="wid">本期分期金额（元）</span>
              <span>{{ nowRow.amount }}</span>
            </div>
            <div class="mb10">
              <span class="wid">滞纳金（元）</span>
              <span>{{ nowRow.lateAmount }}</span>
            </div>
          </div>
          <div class="h_bg p50" style="margin-top: 0">
            <h3>转账信息</h3>
            <span>请根据以下银行信息进行缴费，缴费完成后，上传缴费凭证</span>
          </div>
          <div class="p50">
            <div class="mb10">
              <span class="wid">本期应付金额（元）</span>
              <span class="redF">{{ nowRow.duesAmount }}</span>
            </div>
          </div>
          <div class="radio-group-wrap p50">
            <el-radio-group v-model="formData.payMethod">
              <el-radio label="2">自行转账</el-radio>
              <el-radio label="1">代收代付</el-radio>
            </el-radio-group>
          </div>
          <div class="content-group p50">
            <div class="group-tyep" :class="{ active: formData.payMethod == 2 }">
              <el-form ref="formData" label-position="left" size="mini" label-width="100px">
                <el-form-item label="开户银行">{{ openBank }}</el-form-item>
                <el-form-item label="账户名">{{ accountName }}</el-form-item>
                <el-form-item label="账号">{{ bankAccount }}</el-form-item>
              </el-form>
              <div style="margin: 10px 0">
                <div v-for="(item, index) in formData.payEvidences" :key="index">
                  <span v-if="item.url" class="imgWrapss">
                    <el-image :src="item.url" style="width: 200px; height: 150px"></el-image>
                    <i @click.prevent.stop="del(index)" class="el-icon-delete"></i>
                  </span>
                </div>
                <Upload v-model="fileUrl" buttonText="上传缴费凭证（选填)" @fileNameEvt="payFileNameEvt" :size="true"></Upload>
              </div>
            </div>
            <div class="group-tyep" :class="{active: formData.payMethod == 1}">
              <el-form ref="formData" label-position="left" size="mini">
                <el-form-item label="银行账户" prop="bankAccount">
                  <div class="flex_auto">
                    <el-select v-model="formData.payBankAccount" @change="changeSelectBank()">
                      <el-option v-for="item in bankList" :key="item.bankCard" :label="`${item.bankName}(${item.bankCard.slice(-4)})`" :value="item.bankCard"></el-option>
                    </el-select>
                    <el-button @click="$router.push({name:'managementPersonal'})" style="margin-left: 10px;"> 添加银行卡</el-button>
                  </div>
                </el-form-item>
                <div>
                  <el-checkbox v-model="checked"></el-checkbox>
                  我已阅读，并同意
                  <el-link v-if="info.userType == 2" style="color: rgb(4, 126, 255)" :underline="false" href="https://fdfs.zct.gjsc.info/group1/M00/00/6C/wKgECl-acBCADIq1AAHEh07Ao8Q471.pdf" target="_blank">《企业付款授权协议》</el-link>
                  <el-link v-if="info.userType == 1" style="color: rgb(4, 126, 255)" :underline="false" href="https://fdfs.zct.gjsc.info/group1/M00/00/6C/wKgECl-acJqAYQIhAAHFkrIi8UA284.pdf" target="_blank">《个人付款授权协议》</el-link>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div slot="footer" class="btn">
          <el-button @click="show = false">取 消</el-button>
          <el-button class="sumbit" @click="saveAndSubmitBtn()">确认提交</el-button>
        </div>
      </el-dialog>
      <!-- 转账提示 -->
      <paySure :pay.sync="payInfoSure"  @operateSureEvt="operateSureEvt"> </paySure>
    </div>
  </div>
</template>

<script>
import HeaderImg from '@/components/HeaderImg'
import Dialog from '@/components/Dialog'
import Upload from '@/components/Upload/UpLoad.vue'
import faceQrcode from '@/components/faceQrcodes/index.vue'
import paySure from '@/components/paySure/index.vue'
export default {
  components: {
    HeaderImg,
    Dialog,
    Upload,
    faceQrcode,
    paySure,
  },
  data() {
    return {
      qrShow: false, //代收代付人脸识别
      show: false,
      diaLoading: false,
      nowRow: {}, // 当前行
      formData: {
        id: '',
        payEvidences: [], //支付凭证
        payMethod: '2',
        payBankAccount: '',
        payBankName: '',
        areaId: '',
        feeType: '1',
        userType: '',
        callbackId: '',
      },
      openBank: '',
      accountName: '',
      bankAccount: '',
      fileUrl: '',
      fileNameS: '',
      checked: true,
      bankList: [],
      payInfoSure:{
        accountName: '',
        bankAccount: '',
        amount: '',
      },
      headerList: [
        { name: "首页", path: "/Home" },
        { name: '我的分期', path: '/myStageList' },
        { name: '分期付款', path: '' }],
      loading: false,
      info: {
          // name: '测试数据',
          // stageAmount: 200,
          // stageNum: 2,
          // firstAmount: 100
      },
      tableData: [
          // {
          //   stageNum: 1,
          //   amount: 100,
          //   lateAmount: 0,
          //   duesAmount: 100,
          //   latestDate: '2021-08-03',
          //   actualDate: '2021-07-21',
          //   status: 1
          // },
          // {
          //   stageNum: 2,
          //   amount: 100,
          //   lateAmount: 0,
          //   duesAmount: 100,
          //   latestDate: '2021-08-03',
          //   actualDate: '',
          //   status: 0
          // }
      ]
    }
  },
  watch: {
    fileUrl: {
      handler(newVal) {
        if (newVal) {
          this.formData.payEvidences.push({
            url: newVal,
            name: this.fileNameS,
          })
          this.fileUrl = ''
        }
      },
    },
  },
  created() {
    this.getTransactionList()
  },
  methods: {
    payFileNameEvt(v) {
      this.fileNameS = v
    },
    del(index) {
      if (this.formData.payEvidences.length > 0) {
        this.formData.payEvidences.splice(index, 1)
      }
    },
    //代收代付获取银行卡列表以及选择
    changeSelectBank() {
      if (this.bankList && this.bankList.length > 0) {
        if (this.formData.payBankAccount) {
          this.bankList.forEach((item) => {
            if (this.formData.payBankAccount == item.bankCard) {
              this.formData.payBankName = item.bankName
            }
          })
        }
      } else {
        return this.$message.error(
          '请在页面右上的个人中心-账户管理里面添加银行卡'
        )
      }
    },
    // 获取代收代付银行卡
    async getBankList() {
      await this.$api.user
        .getMyCard({
          type:
            this.info.userType == '2' ? 4 : this.info.userType,
        })
        .then((res) => {
          if (res.code == 1000 && res.data && res.data.length) {
            this.bankList = res.data
            this.bankList.forEach((item) => {
              if (item.isDefault == 1) {
                this.formData.payBankAccount = item.bankCard //银行账户 （必填）
                this.formData.payBankName = item.bankName //开户银行
              }
            })
          }
        })
    },
    //获取自行转账的相关银行信息
    getCompanyInfo() {
      this.diaLoading = true
      this.$api.my
        .getFeeItem({ areaId: this.info.areaConfigId, feeType: '1' })
        .then((res) => {
          if (res.code === 1000) {
            this.openBank = res.data.bankName
            this.accountName = res.data.accountName
            this.bankAccount = res.data.bankCard
          }
        })
        .finally(() => {
          this.diaLoading = false
        })
    },
    operateSureEvt() {
      if (this.formData.payMethod == 1) {
        this.qrShow = true
      } else {
        this.operateEvt()
      }
    },
    notify(v) {
      this.qrShow = false
      if (v) {
        this.formData.callbackId = this.$refs.qr.callbackId
        setTimeout(() => {
          this.operateEvt()
        }, 500)
      }
    },
    operateEvt() {
      this.diaLoading = true
      this.formData.areaId = this.info.areaConfigId
      this.formData.userType = this.info.userType
      this.formData.id = this.nowRow.id
      this.$api.my
        .installmentPayment(this.formData)
        .then((res) => {
          if (res.code === 1000) {
            this.show = false
            this.$message.success('支付成功')
            this.getTransactionList()
          }
        })
        .finally(() => {
          this.diaLoading = false
        })
    },
    //获取详情
    getTransactionList() {
      this.loading = true
      this.$api.my
        .getStageRecord({
            delistingBaseId: this.$route.query.id
        })
        .then((res) => {
          if (res.code == 1000&&res.data) {
            this.info = res.data
            res.data.list&&(this.tableData = res.data.list)
          } else {
            this.$message.error(response.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 分期付款
    payStage(row) {
      this.nowRow = row
      this.getCompanyInfo()
      this.getBankList()
      this.show = true
    },
    // 支付提交
    saveAndSubmitBtn() {
      if (
        this.formData.payMethod == 1 &&
        (!this.formData.payBankAccount || !this.formData.payBankName)
      )
        return this.$message.error('请选择代收代付的银行账户')
      if (this.formData.payMethod == 1 && !this.checked)
        return this.$message.error('请阅读并勾选付款协议')
      if(this.formData.payMethod == 2 && (!this.accountName || !this.bankAccount)) {
          return this.$message.error('当前区域未配置收款银行卡,暂不支持自行转账,请联系管理员')
      } else {
        this.payInfoSure = {
          accountName: this.formData.payMethod == 2 ? this.accountName :this.formData.payBankName,
          bankAccount: this.formData.payMethod == 2 ? this.bankAccount :this.formData.payBankAccount,
          amount: this.nowRow.duesAmount,
        }
      }  
    },
  }
}
</script>
<style scoped>
.table-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding-bottom: 30px;
}
.btn {
  text-align: center;
  margin: auto;
  display: block;
}
</style>